'use strict';

angular.module('mobile-apps')
	.directive('elementAddHighlight',['EntryHighlight', function(EntryHighlight) {
		return {
			restrict: 'E',
			scope:
				{
					baseText : '@',
					entryText : '@',
					sourceText : '@',
					displayField : '@',
					languages : '=',
					isActive : '=',
					watch : '@'
				},
			link: function (scope, elem, attrs) {

				// Makes sure that white spaces do get displayed
				elem.css({'white-space': 'pre-wrap'});


				/**
				 * Refreshed the data with the highlights
				 */
				function refreshDisplayData() {
					// Escape html to not render the actual html of the input
					var htmlEscapedBase = $("<span>").text(scope.baseText).html();
					var htmlEscapedEntry = $("<span>").text(scope.entryText).html();
					var htmlEscapedSource = $("<span>").text(scope.sourceText).html();

					var data = {
						languages: scope.languages
					};

					// Highlight the variables
					var displayText = EntryHighlight.highlightText(htmlEscapedBase, htmlEscapedSource, htmlEscapedEntry, scope.displayField, data, scope.isActive);

					elem.html(displayText);
				};


				// Only add watchers if specified
				if (scope.watch) {
					var watchVariables = scope.watch.split(',');
					if (watchVariables.indexOf('base') !== -1) {
						// Watch for base change
						scope.$watch('baseText', function() {
							refreshDisplayData();
						});
					}
					if (watchVariables.indexOf('entry') !== -1) {
						// Watch for base change
						scope.$watch('entryText', function() {
							refreshDisplayData();
						});
					}
					if (watchVariables.indexOf('source') !== -1) {
						// Watch for base change
						scope.$watch('sourceText', function() {
							refreshDisplayData();
						});
					}
					if (watchVariables.indexOf('active') !== -1) {
						// Watch for base change
						scope.$watch('isActive', function() {
							if (scope.isActive) {
								// When active show all lines
								elem.css({'white-space': 'pre-wrap'});
							} else {
								// When not active show only one line
								elem.css({'white-space': 'nowrap'});
							}
							refreshDisplayData();
						});
					}
				}
			}
		};
	}]);


